<template>
  <div
    class="stream-components-image"
    @click.stop="$emit('click')"
    @mouseenter="$emit('mouseenter')"
    @mouseleave="$emit('mouseleave')"
  >
    <img
      class="stream-components-image__image"
      :src="`${includeDomain ? domain : ''}${src}`"
      alt=""
    >
    <slot />
  </div>
</template>

<script>
import {mapState} from "vuex";
import {getSizedPropValue} from "@/containers/Constructor/containers/Editor/utils";

export default {
  name: "ImageElement",

  props: {
    component: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      domain: process.env.VUE_APP_CONSTRUCTOR_2_BASE_URL,
    };
  },

  computed: {
    ...mapState({
      activeSize: state => state.constructor2.activeSize
    }),

    src () {
      return getSizedPropValue(this.component?.props?.src, this.activeSize) || ''
    },

    includeDomain () {
      return !(this.src.startsWith('http://') || this.src.startsWith('https://'))
    }
  }
}
</script>

<style lang="scss" src="./index.scss"></style>
